var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 15.673,
    y: 39.278,
    style: {
      fill: "#C9E8FA"
    },
    width: 480.653,
    height: 433.445
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#67BFFF"
    },
    d: "M0,23.604v464.791h512V23.604H0z M480.653,457.049H31.347V54.951h449.306V457.049z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 39.278,
    style: {
      fill: "#B6E0F7"
    },
    width: 240.327,
    height: 433.445
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0088FF"
    },
    points: "512,23.604 512,488.396 256,488.396 256,457.049 480.653,457.049 480.653,54.951 256,54.951  256,23.604 "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 23.604,
    style: {
      fill: "#C9AD91"
    },
    width: 512,
    height: 87.761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 23.604,
    style: {
      fill: "#B38A65"
    },
    width: 256,
    height: 87.761
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.646,
    y: 23.604,
    style: {
      fill: "#8A6746"
    },
    width: 114.354,
    height: 87.761
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FD7052"
    },
    points: "411.031,418.795 100.968,418.795 256,140.8 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 240.327,
    y: 258.926,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.347,
    height: 71.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.327,
    y: 345.401,
    style: {
      fill: "#FFFFFF"
    },
    width: 31.347,
    height: 25.673
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4F18"
    },
    points: "256,140.8 411.031,418.795 256,418.795 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 258.926,
    style: {
      fill: "#D9D8DB"
    },
    width: 15.673,
    height: 71.074
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 345.401,
    style: {
      fill: "#D9D8DB"
    },
    width: 15.673,
    height: 25.673
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 421.794,
    y: 59.037,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.932,
    height: 13.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.899,
    y: 59.037,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.932,
    height: 13.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 476.014,
    y: 59.037,
    style: {
      fill: "#FFFFFF"
    },
    width: 13.932,
    height: 13.932
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.784aabfbb410feb132190224ac95e24e.svg";
export { ForwardRef as ReactComponent };